import { createContext } from 'react';

/**
 * The signed-in person's portal role in the app (owner, admin, officer, or null for everyone else),
 * from the getMyRole probe in src/App.js. It only decides what to show: "Fix in Zed" under an answer
 * for owners and admins (src/components/ChatView.js). The server enforces every role on its own.
 */
export const TeamRoleContext = createContext(null);

export default TeamRoleContext;
